import './App.css';
import Dream11Channel from "./Dream11Channel"; 
import Slider from './Slider';



function App() {
  return (
   <div>
    <Dream11Channel />
    <Slider/>

     
   </div>
  );
}

export default App;
